import { isCarId, isCarlineInput } from '../types';
import { conflictDataQuery } from '../graphql/conflict-data-query';
import { STATE_MANAGER_QUERY } from './state-manager-query';
// eslint-disable-next-line no-shadow
export var QueryType;
(function (QueryType) {
    QueryType["DefaultConfig"] = "DefaultConfig";
    QueryType["SpecificConfig"] = "SpecificConfiguration";
    QueryType["ChangeEquipment"] = "ChangeEquipment";
    QueryType["ChangeModel"] = "ChangeModel";
    QueryType["ChangeTrimline"] = "ChangeTrimline";
})(QueryType || (QueryType = {}));
var QueryBuilder = /** @class */ (function () {
    function QueryBuilder(carIdentifier, enableSingleQueryMode) {
        if (enableSingleQueryMode === void 0) { enableSingleQueryMode = false; }
        this._enableSingleQueryMode = false;
        this._queryParts = new Map();
        this._enableSingleQueryMode = enableSingleQueryMode;
        if (isCarId(carIdentifier)) {
            this._carId = carIdentifier;
        }
        else if (isCarlineInput(carIdentifier)) {
            this._carlineInput = carIdentifier;
        }
        else {
            throw new Error('Invalid carIdentifier, is seems not to be a carId or a carlineInput');
        }
    }
    QueryBuilder.prototype.setQueryType = function (queryType) {
        this._queryType = queryType;
        return this;
    };
    QueryBuilder.prototype.getQueryType = function () {
        return this._queryType;
    };
    QueryBuilder.prototype.addQuery = function (featureAppId, carFields, carFieldsForUpdate, variables) {
        if (this._queryParts.has(featureAppId)) {
            throw new Error('This was already added to the QueryBuilder');
        }
        this._queryParts.set(featureAppId, { carFields: carFields, carFieldsForUpdate: carFieldsForUpdate, variables: variables });
        return this;
    };
    /**
     * Test if all the parts needed to build a query are available
     *
     * @returns boolean
     */
    QueryBuilder.prototype._isQueryBuildable = function () {
        return (this._carId || this._carlineInput) && this._queryType && this._queryParts.size > 0;
    };
    QueryBuilder.prototype._createBaseQueryComponents = function () {
        var baseQueryComponents;
        switch (this._queryType) {
            case QueryType.ChangeEquipment:
                baseQueryComponents = {
                    variables: '$configuredCar: ChangeConfiguredCarFeatureInput!',
                    query: 'changeConfiguredCarFeature(input: $configuredCar)',
                    name: 'ChangeEquipment',
                    isChangeQuery: true,
                };
                break;
            case QueryType.ChangeModel:
                baseQueryComponents = {
                    variables: '$configuredCar: ChangeConfiguredCarModelInput!',
                    query: 'changeConfiguredCarModel(input: $configuredCar)',
                    name: 'ChangeModel',
                    isChangeQuery: true,
                };
                break;
            case QueryType.ChangeTrimline:
                baseQueryComponents = {
                    variables: '$configuredCar: ChangeConfiguredCarTrimlineInput!',
                    query: 'changeConfiguredCarTrimline(input: $configuredCar)',
                    name: 'ChangeTrimline',
                    isChangeQuery: true,
                };
                break;
            case QueryType.SpecificConfig:
                baseQueryComponents = {
                    variables: '$configuredCar: ConfiguredCarInput!',
                    query: 'configuredCar(configuredCarIdentifier: $configuredCar)',
                    name: 'SpecificConfiguration',
                    isChangeQuery: false,
                };
                break;
            default:
                baseQueryComponents = {
                    variables: '$configuredCar: ConfiguredCarByCarlineInput!',
                    query: 'configuredCarByCarline(carlineInput: $configuredCar)',
                    name: 'DefaultConfiguration',
                    isChangeQuery: false,
                };
        }
        return baseQueryComponents;
    };
    QueryBuilder.prototype.buildQuery = function () {
        var _this = this;
        if (!this._isQueryBuildable()) {
            throw new Error("Query can't be build");
        }
        var baseQueryComponents = this._createBaseQueryComponents();
        var queryParts = "";
        // Sort by featureAppId to try to always get the same order of fields in the query
        var sortedQueryParts = Array.from(this._queryParts).sort(function (_a, _b) {
            var k1 = _a[0];
            var k2 = _b[0];
            return k1.localeCompare(k2);
        });
        var includeFinancingInput = false;
        sortedQueryParts.forEach(function (_a) {
            var featureAppId = _a[0], _b = _a[1], carFields = _b.carFields, carFieldsForUpdate = _b.carFieldsForUpdate, variables = _b.variables;
            var subscriberQueryPart = _this._queryType === QueryType.ChangeEquipment &&
                carFieldsForUpdate &&
                carFieldsForUpdate.length > 0
                ? carFieldsForUpdate
                : carFields;
            if (variables && variables.length > 0) {
                variables
                    .sort(function (_a, _b) {
                    var a = _a.rawName;
                    var b = _b.rawName;
                    return a.localeCompare(b);
                })
                    .forEach(function (variable) {
                    baseQueryComponents.variables += ", ".concat(variable.name, ": ").concat(variable.type);
                    // We need to mask with \\ because the varname
                    // contains a $ wich has a special meanign in regexp
                    subscriberQueryPart = subscriberQueryPart.replace(new RegExp("\\".concat(variable.rawName), 'g'), variable.name);
                });
            }
            if (subscriberQueryPart.includes('$financingInput')) {
                includeFinancingInput = true;
            }
            queryParts += "\n            ".concat(featureAppId, ": ").concat(baseQueryComponents.query, " {\n                ").concat(baseQueryComponents.isChangeQuery ? 'configuredCar {' : '', "\n                    ").concat(subscriberQueryPart, "\n                ").concat(baseQueryComponents.isChangeQuery
                ? "} ".concat(_this._enableSingleQueryMode && featureAppId === 'STATEMANAGER'
                    ? conflictDataQuery
                    : '')
                : '', "\n\n            }\n        ");
        });
        if (!this._enableSingleQueryMode) {
            includeFinancingInput = true;
            queryParts += "\n        STATEMANAGER: ".concat(baseQueryComponents.query, " {\n            ").concat(baseQueryComponents.isChangeQuery ? 'configuredCar {' : '', "\n            ").concat(STATE_MANAGER_QUERY, "\n            ").concat(baseQueryComponents.isChangeQuery ? "} ".concat(conflictDataQuery) : '', "\n        }\n    ");
        }
        if (includeFinancingInput) {
            baseQueryComponents.variables += ', $financingInput: FinancingInput';
        }
        var result = "query ".concat(baseQueryComponents.name, "(").concat(baseQueryComponents.variables, ") {\n        ").concat(queryParts, "\n    }");
        return result;
    };
    return QueryBuilder;
}());
export { QueryBuilder };
//# sourceMappingURL=query-builder.js.map